import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-reveal';
import { Section } from '@/features/new-landing-page/components/section';
import { StrapiTextual } from '@/features/strapi/components/textual';
import { IntegrationsContent } from '@/features/new-landing-page/pages/homepage-content';
import { StrapiIntegrationCard } from '@/features/strapi/components/integration-card';
import { VSpace } from '@/components/spacing';
// @ts-ignore
import loox from '../assets/integrations/loox.png';

export function IntegrationsSection() {
  const firstFour = IntegrationsContent.integrations.slice(0, 4);
  const others = IntegrationsContent.integrations.slice(4);

  return (
    <CustomSection>
      <VSpace value={6} mobileValue={3} />
      <StrapiTextual {...IntegrationsContent.title} />
      <VSpace value={1} />
      <StrapiTextual {...IntegrationsContent.subtitle} />
      <VSpace value={6} />
      <IntegrationsRow className="only-desktop" count={4}>
        <Fade bottom>
          {firstFour.map((integration) => (
            <StrapiIntegrationCard key={integration.image} {...integration} />
          ))}
        </Fade>
      </IntegrationsRow>
      <VSpace value={3} />
      <IntegrationsRow className="only-desktop" count={5}>
        <Fade bottom>
          {others.map((integration) => (
            <StrapiIntegrationCard key={integration.image} {...integration} />
          ))}
        </Fade>
      </IntegrationsRow>
      <IntegrationsColumn className="only-mobile">
        <Fade bottom>
          {IntegrationsContent.integrations.map((integration) => (
            <img key={integration.image} src={integration.image} alt="" />
          ))}
          <img style={{ height: `2.5rem` }} src={loox} alt="" />
        </Fade>
      </IntegrationsColumn>
      <VSpace value={6} />
      <StrapiTextual
        {...IntegrationsContent.footer}
        style={{
          ...IntegrationsContent.footer.style,
          color: `#A6AFB8`,
          letterSpacing: `-1px`,
        }}
      />
      <VSpace value={6} />
    </CustomSection>
  );
}

const CustomSection = styled(Section)`
  && {
    && > * {
      margin-bottom: 0rem;
    }
  }
`;

const IntegrationsRow = styled.div`
  max-width: 70%;
  width: 70%;
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: repeat(
    ${(props: { count: number }) => props.count},
    26rem
  );
  grid-template-rows: max-content;
  grid-gap: 2rem;

  & > * > * {
    height: 100%;
    min-height: 25rem;
  }
`;

const IntegrationsColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 6rem;
  padding: 0 4rem;

  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
`;
